// extracted by mini-css-extract-plugin
export var bubble = "_3p-0";
export var container = "_3p-3";
export var contrastBorder = "_3p-4";
export var greyOut = "_3p-2";
export var initialsWrapper = "_3p-1";
export var large = "_3p-9";
export var medium = "_3p-8";
export var mediumSmall = "_3p-7";
export var mediumSmallMedium = "_3p-c";
export var micro = "_3p-5";
export var small = "_3p-6";
export var tiny = "_3p-b";
export var xTiny = "_3p-a";